(function(){
'use strict';

// TODO: we should eventually refactor this to use the new toggle component instead which follows one-way binding and immutability. Right now, only reverseOrientation is using it
angular.module('classy').component('toggleField', {
  template: '\n    <div class="toggle-field_container" ng-class="{ \'toggle-field_container-reverse\': $ctrl.reverseOrientation, \'admin-body__lock-field\':$ctrl.lockField }">\n      <div class="form_togglegroup" ng-if="$ctrl.reverseOrientation">\n        <toggle sc-name="$ctrl.name"\n          initial-value="$ctrl.initialValue"\n          toggle-click="$ctrl.onToggleClick(checked)"\n          disabled="$ctrl.disabled || $ctrl.lockField"\n          class="form_togglegroup-toggle"\n        ></toggle>\n      </div>\n      \n      <div class="form__label"\n        required="$ctrl.required"\n        ng-if="$ctrl.label"\n        ng-class="{\'inline\': !$ctrl.sublabel}"\n        _spec="label"\n        ng-bind="::$ctrl.label"\n      ></div>\n  \n      <span class="form__sublabel"\n        ng-if="$ctrl.sublabel"\n        ng-bind="::$ctrl.sublabel"\n      ></span>\n  \n      <div class="form_togglegroup" ng-if="!$ctrl.reverseOrientation" ng-class="{\'form__text-input__outer\':$ctrl.lockField}">\n        <label class="form_togglegroup-element"\n          for="$ctrl.name"\n          ng-if="$ctrl.noLabel">{{ ::$ctrl.noLabel }}</label>\n\n          <div ng-if="$ctrl.lockField"\n          data-sc-tooltip-class="admin-campaign-tooltip lock-tooltip-msg"\n          data-sc-tooltip-position="left"\n          data-sc-tooltip-position-tip="bottom center"\n          show-event="\'mouseenter\'" hide-event="\'mouseout\'"\n          fixed-tooltip="true"\n          data-sc-tooltip="\'This field is locked at the template level.\'"\n          class="form_togglegroup-toggle admin-body__tooltip-element"></div>\n    \n          <span class="form_togglegroup-toggle"\n            data-sc-toggle="$ctrl.model"\n            data-callback-fn="$ctrl.callbackFn()"\n            data-sc-disabled="$ctrl.disabled || $ctrl.lockField"\n            data-sc-name="{{$ctrl.name}}"\n            data-sc-flipped="$ctrl.flipped"\n            data-sc-label="{{$ctrl.toggleLabel}}"\n          ></span>\n  \n        <label class="form_togglegroup-element"\n          for="$ctrl.name"\n          ng-if="$ctrl.yesLabel"\n        >{{::$ctrl.yesLabel}}</label>\n      </div>\n    \n    </div>\n  ',
  bindings: {
    model: '=',
    disabled: '=?',
    label: '<?',
    sublabel: '<?',
    noLabel: '<?',
    yesLabel: '<?',
    name: '<',
    required: '<?',
    errorMessages: '<?',
    getterSetter: '<?',
    flipped: '=?',
    reverseOrientation: '<',
    initialValue: '<',
    toggleClick: '&',
    toggleLabel: '@',
    callbackFn: '&?'
  },
  // eslint-disable-next-line no-unused-vars
  controller: ["$attrs", "$window", "$stateParams", "scCampaignsTemplateService", function toggleFieldCtrl($attrs, $window, $stateParams, scCampaignsTemplateService) {
    var _this2 = this;

    var DEFAULTS = {
      errorMessages: {
        required: 'This field is required.'
      },
      getterSetter: false,
      placeholder: '',
      required: false,
      flipped: false
    };

    this.$onInit = function () {
      var _this = this;

      _.defaultsDeep(this, DEFAULTS);

      this.lockField = false;

      this.getLockedField = function (type) {
        var fieldName = $attrs.model.split('.').splice(-1)[0];
        if (_.includes(['teams_can_set_appeal', 'teams_can_set_goal', 'pages_can_set_appeal', 'pages_can_set_goal'], fieldName)) {
          return scCampaignsTemplateService.getCampaignSettingLock(fieldName);
        } else {
          var lockedBlock = scCampaignsTemplateService.getBlockByType(type);
          return lockedBlock && lockedBlock.item_attributes[fieldName] && lockedBlock.item_attributes[fieldName].locked;
        }
      };

      /**
       * Template Locks for Email Content Contact Support Block
       */
      if (SC.campaign && SC.campaign.campaignTemplateData) {
        var chosenParamId = scCampaignsTemplateService.fetchCurrentBlockId($window);

        if ($attrs.model === 'holding.showCustomQuestions' && $attrs.label === "'Show custom question block'" || $attrs.model === 'thisBlock.properties.showTaxDeductible') {
          var activeEmail = null;
          var foundEmailPayload = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          activeEmail = scCampaignsTemplateService.getActiveEmail(foundEmailPayload);
          if (activeEmail) {
            var combinedBlocks = scCampaignsTemplateService.combineBlocks(activeEmail);
            _.forEach(combinedBlocks, function (value) {
              if (value.blockProp && value.blockProp.name === 'donation-receipt') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'rwf-receipt') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'rwf-receipt-summary') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        if ($attrs.model === 'holding.showBlock' && $attrs.label === "'Show manage donation block'") {
          var _activeEmail = null;
          var _foundEmailPayload = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          _activeEmail = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload);
          if (_activeEmail) {
            var _combinedBlocks = scCampaignsTemplateService.combineBlocks(_activeEmail);
            _.forEach(_combinedBlocks, function (value) {
              if (value.blockProp && value.blockProp.name === 'manage-donation') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        if ($attrs.model === 'holding.showBlock' && $attrs.label === "'Event block'") {
          var _activeEmail2 = null;
          var _foundEmailPayload2 = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          _activeEmail2 = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload2);
          if (_activeEmail2) {
            var _combinedBlocks2 = scCampaignsTemplateService.combineBlocks(_activeEmail2);
            _.forEach(_combinedBlocks2, function (value) {
              if (value.blockProp && value.blockProp.name === 'event') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        if ($attrs.model === 'thisBlock.properties.showImage' && $attrs.label === "'Background image'" || $attrs.model === 'holding.showBlock' && $attrs.label === "'Show custom question block'") {
          var _activeEmail3 = null;
          var _foundEmailPayload3 = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          _activeEmail3 = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload3);
          if (_activeEmail3) {
            var _combinedBlocks3 = scCampaignsTemplateService.combineBlocks(_activeEmail3);
            _.forEach(_combinedBlocks3, function (value) {
              if (value.blockProp && value.blockProp.name === 'image') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'rwf-custom-questions') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        if ($attrs.model === 'holding.showBlock' && $attrs.label === "'Contact block'") {
          var _activeEmail4 = null;
          var _foundEmailPayload4 = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          _activeEmail4 = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload4);
          if (_activeEmail4) {
            var _combinedBlocks4 = scCampaignsTemplateService.combineBlocks(_activeEmail4);
            _.forEach(_combinedBlocks4, function (value) {
              if (value.blockProp && value.blockProp.name === 'contact-support') {
                _this.lockField = value.locked;
              }
            });
          }
        }
      }

      this.getLockedFieldForSetUp = function (step) {
        if (step === 'landing') {
          var lockLeaderboardBlock = scCampaignsTemplateService.getBlockByType('fundraisers');
          var lockHeroBlock = scCampaignsTemplateService.getBlockByType('crowdfunding');
          var fieldName = $attrs.model.split('.').splice(-1)[0];

          if (lockLeaderboardBlock && _.includes(['showLeaderboard', 'showTeams', 'showIndividuals'], fieldName)) {
            _this.lockField = lockLeaderboardBlock.item_attributes[fieldName] && lockLeaderboardBlock.item_attributes[fieldName].locked;
          }

          if (lockHeroBlock && fieldName === 'replaceHeadline') {
            _this.lockField = lockHeroBlock.item_attributes[fieldName] && lockHeroBlock.item_attributes[fieldName].locked;
          }
        }
      };

      if (SC.campaign && SC.campaign.campaignTemplateData) {
        var blockObj = _.find(SC.blocks, { id: $stateParams.blockId });
        if (blockObj) {
          this.lockField = this.getLockedField(blockObj.type);
        } else {
          this.getLockedFieldForSetUp($stateParams.step);
        }
      }
    };

    this.onToggleClick = function (checked) {
      _this2.toggleClick({ checked: checked });
    };
  }]
});
})();